import { render, staticRenderFns } from "./SpacingEditor.vue?vue&type=template&id=497a3387&scoped=true"
import script from "./SpacingEditor.vue?vue&type=script&lang=js"
export * from "./SpacingEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497a3387",
  null
  
)

export default component.exports